import React, { useEffect } from "react";
import { Select } from "antd";
import { AdsSortOption, AdsSortOptionText, AdStatus, AllPromotionStatus, AllTypeCategory } from "../../models";
import SearchText from "./controls/SearchText";

import styles from "./styles/SearchBar.scss";
import { ModulesI } from "../../typings/routesTypes";
import SortOption from "../SortOption";

interface SearchBarProps {
  text?: string;
  module?: string;
  sortOption?: string;
  modules?: ModulesI[];
  status?: number;
  adPromotionFilter?: number;
  AdPromotionFilterOptions?: { name: string; value: number }[];
  onModuleSearch?: () => void;
  onTextSearch?: () => void;
  onPromotionStatusSearch?: (status: any) => void;
  onSortOptionChange?: (value: any) => void;
}

// eslint-disable-next-line max-lines-per-function
function SearchBar(props: SearchBarProps) {
  const {
    text,
    module: currentModule,
    modules,
    status,
    adPromotionFilter,
    AdPromotionFilterOptions,
    onTextSearch,
    onModuleSearch,
    onPromotionStatusSearch,
    onSortOptionChange,
    sortOption,
  } = props;

  useEffect(() => {
    if (status !== AdStatus.active) {
      onPromotionStatusSearch(undefined);
    }
  }, [status]);

  return (
    <div className={`page-search-bar ${styles.container}`}>
      <div className={styles.controls}>
        {!onTextSearch ? null : (
          <SearchText
            placeholder={"Pretraga (min 3 znaka)"}
            size="large"
            defaultValue={text}
            onChange={onTextSearch}
          />
        )}

        <Select
          onChange={onModuleSearch}
          defaultValue={currentModule}
          value={currentModule}
          className={styles.adModule}
        >
          <Select.Option
            key={AllTypeCategory.name}
            value={AllTypeCategory.name}
          >
            {AllTypeCategory.displayName}
          </Select.Option>
          {modules.map(module => (
            <Select.Option key={module.name} value={module.name}>
              {module.displayName}
            </Select.Option>
          ))}
        </Select>

        {!onPromotionStatusSearch || status !== AdStatus.active ? null : (
          <Select
            onChange={onPromotionStatusSearch}
            value={adPromotionFilter}
            defaultValue={adPromotionFilter}
            className={styles.adPromotionStatus}
          >
            <Select.Option
              key={AllPromotionStatus.name}
              value={AllPromotionStatus.name}
            >
              {AllPromotionStatus.displayName}
            </Select.Option>
            {AdPromotionFilterOptions.map(status => (
              <Select.Option key={status.name} value={status.value}>
                {status.name}
              </Select.Option>
            ))}
          </Select>
        )}
        {onSortOptionChange && <SortOption
          onSortClick={onSortOptionChange}
          selectedOption={sortOption}
          classNameDesktop={styles.sortOption}
          includeSortOptionClassName={false}
          options={AdsSortOptionText.filter(filterItem => filterItem.value !== AdsSortOption.mostRelevant)}
        />}

      </div>
    </div>
  );
}

SearchBar.defaultProps = {
  text: "",
  module: AllTypeCategory.name,
  adPromotionFilter: AllPromotionStatus.name,
  status: AdStatus.active,
  AdPromotionFilterOptions: []
};

export default SearchBar;



// WEBPACK FOOTER //
// ./src/components/SearchBar/index.tsx